module.exports = __webpack_public_path__ + "files/poulain.c0adbabdc211c3b6809174c2addccebf.pdf";